import Axios from "../baseApi";

export default {
  async fetch() {
    return await Axios.get('/api-master-data/v1/place');
  },
  async create(data, type) {
    return await Axios.put(`/api-master-data/v1/place?type=${type}`, data);
  },
  update(data, type) {
    return Axios.post(`/api-master-data/v1/place?type=${type}`, data);
  },
  async delete(id, type) {
    return await Axios.delete('/api-master-data/v1/place/' + type + '/' + id);
  },
  async fetchCountries() {
    return await Axios.get('/api-master-data/v1/place/countries');
  },
  async fetchPlaces(countryId) {
    return await Axios.get(`/api-master-data/v1/place/places/${countryId}`);
  },
  async fetchStates() {
    return await Axios.get(`/api-master-data/v1/state`);
  },
}
